import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react'
import { HYDRATE } from 'next-redux-wrapper'

import { MultipleChoiceTestData } from '~/types/multiple-choice'
import { SANITY } from '~/services/sanity.service'
import { apiPrivate } from '~/redux/utils/hom-api'

export const multipleChoiceTestApi = createApi({
  reducerPath: 'multipleChoiceTestApi',
  baseQuery: apiPrivate,
  tagTypes: ['MultipleChoiceTest'],
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
  endpoints: (builder) => ({
    getMultipleChoiceTest: builder.query<MultipleChoiceTestData, { url: string }>({
      queryFn: async ({ url }) => {
        try {
          return { data: await SANITY.getMultipleChoiceTest({ url }) }
        } catch (error) {
          return { error: error as FetchBaseQueryError }
        }
      },
    }),

    getMultipleChoiceTests: builder.query<Array<{ url: string }>, { drillUrl: string }>({
      queryFn: async ({ drillUrl }) => {
        try {
          return { data: await SANITY.getMultipleChoiceTests({ drillUrl }) }
        } catch (error) {
          return { error: error as FetchBaseQueryError }
        }
      },
    }),
  }),
})

export const {
  useGetMultipleChoiceTestQuery,
  useGetMultipleChoiceTestsQuery,
  util: { getRunningQueriesThunk },
} = multipleChoiceTestApi

export const { getMultipleChoiceTest, getMultipleChoiceTests } = multipleChoiceTestApi.endpoints
